import React, { FunctionComponent, useState } from 'react'
import styled from 'styled-components'
import { useAppHandlers } from '../../../../services/actions/app/useAppHandlers'
import { useAuthStore } from '../../../../stores/auth/useAuthStore'
import { useOwnApiKey } from './useOwnApiKey'
import { ApiKeyVisibilityToggle, MASKED_API_KEY } from './ApiKeyVisibility'
import Row from '../../../../components/Row'
import Text from '../../../../components/Text'
import ActionText from '../../../../components/ActionText'
// @ts-ignore
import { Helmet } from 'react-helmet'

declare global {
    namespace JSX {
        interface IntrinsicElements {
            'zapier-workflow': any;
        }
    }
}

interface IZapierProps {}

const ZAPIER_CLIENT_ID = 'FrDRC1A31gr2CQA18qhx747irTD8XIa4yZBULCft' //todo: change to env variable

const Zapier: FunctionComponent<IZapierProps> = () => {
    const { store: { user } } = useAuthStore()
    const apiKey = useOwnApiKey()
    const [keyVisible, setKeyVisible] = useState(false)
    const { showSuccessToast } = useAppHandlers()

    const handleCopyApiKey = () => {
        if (apiKey && navigator?.clipboard?.writeText) {
            navigator.clipboard.writeText(apiKey)
            showSuccessToast({message: 'API Key copied to clipboard'})
        }
    }

    return (
        <Container>
            <Helmet>
                <script 
                    type="module" 
                    src="https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.esm.js"
                />
                <link 
                    rel="stylesheet" 
                    href="https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.css"
                />
            </Helmet>
            <ApiKeyRow>
                <Text $heading6>API Key: {apiKey && (keyVisible ? apiKey : MASKED_API_KEY)}</Text>
                {apiKey && (
                    <>
                        <ApiKeyVisibilityToggle visible={keyVisible} onToggle={() => setKeyVisible(previous => !previous)} />
                        <ActionText onClickHandler={handleCopyApiKey}>Copy</ActionText>
                    </>
                )}
            </ApiKeyRow>
            <WorkflowContainer>
                <zapier-workflow
                    client-id={ZAPIER_CLIENT_ID}
                    sign-up-email={user?.email}
                    sign-up-first-name={user?.firstName}
                    sign-up-last-name={user?.lastName}
                    theme="light"
                    intro-copy-display="show"
                    guess-zap-display="hide"
                    app-selection-display="hide"
                    template-limit="10"
                    zap-create-from-scratch-display="hide"
                />
            </WorkflowContainer>
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    padding: 16px 16px 16px 16px;
`

const ApiKeyRow = styled(Row)`
    width: 100%;
    margin-bottom: 16px;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
`

const WorkflowContainer = styled.div`
    width: 100%;
    min-height: 500px;
`

export default Zapier
